import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { URLS } from '@wix/da-url';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData } from '@wix/da-bi/pkg/events';
import { useLayoutActions } from '../../../hooks/useLayoutActions';
import s from './WidgetTypeCard.scss';
const WidgetTypeCard = ({ className, zone, position, installableWidget })=>{
    const { t } = useTranslation();
    const { addModule } = useLayoutActions();
    const logBiEvent = useBiLogger();
    const { hasCoreMembership } = useContext(SessionContext);
    const { module: { moduleName, restrict, biReferralType }, widgetCard } = installableWidget;
    if (!widgetCard || !addModule) {
        return null;
    }
    const { title, description, minuatureImageSrc, isNew } = widgetCard;
    const coreLimit = restrict && restrict.priv === 'core' ? restrict.limit : 0;
    const isCoreOnlyModule = !!coreLimit;
    const needsCoreForThis = isCoreOnlyModule && !hasCoreMembership; // deviation_gruser TODO why did it also check for installedCount >= limit here?
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], isNew && s['new'], needsCoreForThis && s['locked'], className),
        onClick: ()=>{
            if (needsCoreForThis) {
                // deviation_gruser TODO
                // don't forget to set it for the next modules:
                //   case 'papiCustombox':
                //     return ReferralType.CUSTOM_BOX;
                //   case 'userstats':
                //     return ReferralType.USER_STATS;
                const referral_info = biReferralType;
                logBiEvent({
                    evid: BiEventType.BUY_CORE_BUTTON,
                    referral_info
                });
                window && window.open(URLS.CORE_MEMBERSHIP, '_blank');
                return;
            }
            addModule(moduleName, position);
            logBiEvent(BiData({
                evid: 283,
                widgetname: moduleName,
                widgetzone: zone
            }));
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['minuature-wrapper'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['miniature'],
        style: {
            backgroundImage: `url(${minuatureImageSrc})`
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title, isNew && /*#__PURE__*/ React.createElement(BetaBadge, {
        className: s['new-badge'],
        variant: "small",
        badgeType: "new"
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), needsCoreForThis && /*#__PURE__*/ React.createElement("div", {
        className: s['core-upsell-overlay']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['core-upsell-overlay-text']
    }, t('widgets.coreUpsell.becomeCore.toUnlock', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        count: coreLimit,
        coreBadge: /*#__PURE__*/ React.createElement(CoreBadge, {
            size: "small",
            className: s['core-badge']
        }),
        coreLimit
    }))));
};
export default WidgetTypeCard;
